import { Theme, linearProgressClasses } from "@mui/material";
import { colors } from "../../theme/colors";

export const container = ({ breakpoints }: Theme) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  minHeight: "95vh",
});

export const bodyContainer = ({ breakpoints }: Theme) => ({
  width: { xs: "100%", sm: "500px" },
  height: "100%",
  background: colors.main_gradient,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  borderRadius: { xs: "50px 50px 0 0", sm: "50px" },
  mt: "90px",
  py: "40px",
  boxShadow: {
    sm: "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);",
  },
});

export const subContainer = ({ breakpoints }: Theme) => ({
  mx: "30px",
  width: "100%",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  maxWidth: { xs: "350px", sm: "440px" },
});

export const titleText = ({ breakpoints }: Theme) => ({
  color: "white",
  fontSize: "24px",
  fontWeight: 600,
  textAlign: "center",
});

export const informationContainer = ({ breakpoints }: Theme) => ({
  backgroundColor: "white",
  borderRadius: "25px",
  p: "40px 20px",
  mt: 3,
  maxWidth: "400px",
});

export const itemText = ({ breakpoints }: Theme) => ({
  color: colors.light_black,
  fontSize: "16px",
  fontWeight: 600,
  lineHeight: "27px",
});

export const termsText = ({ breakpoints }: Theme) => ({
  color: colors.light_black,
  fontSize: "16px",
  fontWeight: 600,
  lineHeight: "27px",
  maxWidth: "300px",
  marginRight: 1,
});

export const termsContainer = ({ breakpoints }: Theme) => ({
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between",
  alignItems: "center",
  m: "80px 10px",
  maxWidth: "400px",
});

export const buttonContainer = ({ breakpoints }: Theme) => ({
  display: "flex",
  width: "100%",
  height: "50px",
  flexDirection: "row",
  justifyContent: "space-between",
  alignItems: "center",
});

export const backButton = ({ breakpoints }: Theme) => ({
  color: "white",
  backgroundColor: colors.light_black,
  "&:hover": {
    backgroundColor: colors.light_black,
  },
  margin: "100px 0",
  width: "150px",
  height: "50px",
  fontWeight: "500",
  fontSize: "18px",
});

export const nextButton = ({ breakpoints }: Theme) => ({
  color: "white",
  backgroundColor: colors.main,
  "&:hover": {
    backgroundColor: colors.main,
  },
  margin: "100px 0",
  width: "150px",
  height: "50px",
  fontWeight: "500",
  fontSize: "18px",
});

export const acceptButton = ({ breakpoints }: Theme) => ({
  color: "white",
  backgroundColor: colors.red,
  "&:hover": {
    backgroundColor: colors.red,
  },
  margin: "100px 0",
  width: "150px",
  height: "50px",
  fontWeight: "500",
  fontSize: "18px",
});

export const borderLinearProgress = ({ breakpoints }: Theme) => ({
  height: 15,
  width: "100%",
  mt: 2,
  borderRadius: 7.5,
  borderColor: "black",
  borderWidth: 1,
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor: "#E7EAE1",
  },
  [`& .${linearProgressClasses.bar}`]: {
    borderRadius: 5,
    backgroundColor: "#DF1545",
  },
});

export const input = ({ breakpoints }: Theme) => ({
  mt: 1,
  borderRadius: 4,
  input: {
    background: "white",
    borderRadius: "6px",
  },
});

export const divider = ({ breakpoints }: Theme) => ({
  width: "100%",
  "&::before, &::after": {
    borderColor: colors.light_gray,
  },
  color: colors.dark_gray,
  mt: 1,
  mb: 1,
});

export const authButton = ({ breakpoints }: Theme) => ({
  backgroundColor: colors.main,
  "&:hover": {
    backgroundColor: colors.main,
  },
  fontWeight: 600,
});

export const googleButton = ({ breakpoints }: Theme) => ({
  color: "black",
  textTransform: "none",
  backgroundColor: "white",
  "&:hover": {
    backgroundColor: "white",
  },
  fontWeight: 600,
});

export const subTitle = ({ breakpoints }: Theme) => ({
  color: colors.main,
  fontSize: "16px",
  fontWeight: 600,
  lineHeight: "22.4px",
});

export const imageContainer = ({ breakpoints }: Theme) => ({
  borderRadius: "25px",
  backgroundColor: "white",
  p: 2,
  height: "200px",
  mt: 1,
});

export const imgButtonContaier = ({ breakpoints }: Theme) => ({
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
});

export const modalContainer = ({ breakpoints }: Theme) => ({
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 350,
  // height: 700,
  bgcolor: "background.paper",
  boxShadow: 24,
  borderRadius: "16px",
});

export const checkBoxContainer = ({ breakpoints }: Theme) => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  p: "0 20px",
});

export const checkBoxText = ({ breakpoints }: Theme) => ({
  fontSize: "18px",
  fontWeight: 600,
  color: colors.light_black,
});

export const titleContainer = ({ breakpoints }: Theme) => ({
  backgroundColor: "white",
  width: "98%",
  py: "5px",
  pl: "10px",
});

export const gradeItemContainer = ({ breakpoints }: Theme) => ({
  display: "flex",
  justifyContent: "space-evenly",
  alignItems: "center",
  mt: 2,
});

export const gradeText = ({ breakpoints }: Theme) => ({
  fontSize: "16px",
  fontWeight: 600,
  color: colors.light_black,
});

export const signatureContainer = ({ breakpoints }: Theme) => ({
  height: "300px",
  width: "100%",
  borderRadius: "25px",
  backgroundColor: "white",
  mt: 3,
  mb: 3,
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
});

export const clearButton = ({ breakpoints }: Theme) => ({
  bgcolor: colors.light_black,
  width: "100px",
  "&:hover": {
    bgcolor: colors.light_black,
  },
});

export const saveButton = ({ breakpoints }: Theme) => ({
  bgcolor: colors.main,
  width: "100px",
  "&:hover": {
    bgcolor: colors.main,
  },
});

export const legalContainer = ({ breakpoints }: Theme) => ({
  width: "95%",
  height: "500px",
  borderRadius: "25px",
  bgcolor: "white",
  p: "20px 10px",
  overflowY: "scroll",
  webkitUserSelect: "none",
  mozUserSelect: "none",
  msUserSelect: "none",
  userSelect: "none",
});

export const rescanButton = ({ breakpoints }: Theme) => ({
  color: "white",
  backgroundColor: colors.light_black,
  "&:hover": {
    backgroundColor: colors.light_black,
  },
  m: 4,
  pr: 2,
  pl: 2,
  height: "50px",
  fontWeight: "500",
  fontSize: "18px",
});
